import { useWatch } from 'react-hook-form';

import type { MaxLetterCount } from 'shared/components/form/types';

export const useLetterCounter = (
  name: string,
  maxLetterCount?: MaxLetterCount,
) => {
  const field = useWatch({ name });

  if (!maxLetterCount) {
    return null;
  }

  return `${field.length}/${maxLetterCount}`;
};
